import { useStaticQuery, graphql } from 'gatsby'

export const useQueryPropertyByBrand = (brand: string, id: string) => {
  const { allSitePage } = useStaticQuery(
    graphql`
      query Properties {
        allSitePage(filter: { context: { category: { eq: "property" }, type: { eq: "overview" } } }) {
          nodes {
            context {
              property {
                details {
                  brand
                  id
                }
              }
            }
            path
          }
        }
      }
    `
  )

  const filterdByBrand = allSitePage.nodes.filter((prop: any) => prop.context.property.details.brand === brand)

  return filterdByBrand
}
